import React, { FC } from 'react';
import { Notification } from '../../../common/model/dto/notification/notification';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import OvButton from '../atoms/OvButton';
import Variables from '../../../design-system/variables';
import Colours from '../../../design-system/colours';
import OvListTableField from '../atoms/OvListTableField';
import StringUtils from '../../../common/utils/services/string-utils';
import DateUtils from '../../../common/utils/services/date-utils';
import { NotificationContentDataUtils } from '../../../common/utils/services/notification-content-utils';

const OvNotificationListRow: FC<{
  notification: Notification;
}> = ({ notification }) => {
  const { t } = useTranslation();

  const notificationContentCategoryProps =
    NotificationContentDataUtils.getNotificationContentProps(
      notification.notification_content.category
    );

  return (
    <>
      <OvListTableField
        style={{
          color: notification.is_approvement_pending
            ? Colours.OV_YELLOW
            : 'inherit',
        }}
      >
        {StringUtils.displayValue(
          `${notification?.notification_content?.title || '-'}`
        )}
      </OvListTableField>
      <OvListTableField
        style={{
          color: notification.is_approvement_pending
            ? Colours.OV_YELLOW
            : 'inherit',
        }}
      >
        {StringUtils.displayValue(`${notification?.user?.email || '-'}`)}
      </OvListTableField>
      <OvListTableField
        style={{
          color: notificationContentCategoryProps.notificationContentColor,
        }}
      >
        {StringUtils.displayValue(
          notificationContentCategoryProps.notificationContentCategoryDisplay
        )}
      </OvListTableField>
      <OvListTableField
        style={{
          color: notification.is_approvement_pending
            ? Colours.OV_YELLOW
            : 'inherit',
        }}
      >
        {StringUtils.getPrettifiedBooleanValue(
          notification?.is_approvement_pending
        )}
      </OvListTableField>
      <OvListTableField>
        {StringUtils.getPrettifiedBooleanValue(notification?.is_visible)}
      </OvListTableField>
      <OvListTableField
        style={{
          color: notification.is_approvement_pending
            ? Colours.OV_YELLOW
            : 'inherit',
        }}
      >
        {notification?.created_at
          ? DateUtils.formatDate(
              notification?.created_at as unknown as Date,
              'MMMM DD, YYYY, HH:mm:ss'
            )
          : '-'}
      </OvListTableField>
      <OvListTableField>
        <StyledOvButton>
          <NavLink to={`/notifications/${notification.id}`}>
            {t('common.actions.seeDetails')}
          </NavLink>
        </StyledOvButton>
      </OvListTableField>
    </>
  );
};

export default OvNotificationListRow;

const StyledOvButton = styled(OvButton)`
  && {
    border-radius: ${Variables.borderRadius.CLINIC_DASHBOARD_LARGE};
    padding: 0;
    margin: 0;
    background-color: ${Colours.OV_BASE};
    white-space: nowrap;

    &:hover {
      a {
        color: ${Colours.OV_BASE};
      }
    }

    a {
      border-radius: ${Variables.borderRadius.CLINIC_DASHBOARD_LARGE};
      padding: 0.25rem 1rem;
      text-decoration: none;
      text-transform: none;
      font-weight: bold;
      font-size: 0.75rem;
      color: ${Colours.OV_WHITE};
    }
  }
`;
